var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifyMeBellOutlined16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57464_139001)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.5C8.55228 2.5 9 2.05228 9 1.5C9 0.947715 8.55228 0.5 8 0.5C7.44772 0.5 7 0.947715 7 1.5C7 2.05228 7.44772 2.5 8 2.5ZM8 16.5C9.10457 16.5 10 15.6046 10 14.5C10 13.4851 9.24404 13.491 8.26448 13.4986C8.17794 13.4993 8.08966 13.5 8 13.5C7.91034 13.5 7.82206 13.4993 7.73552 13.4986C6.75596 13.491 6 13.4851 6 14.5C6 15.6046 6.89543 16.5 8 16.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3807 13C12.1773 11.7835 11.5019 10.141 11.5019 8.42893V6.5C11.5019 4.567 9.93485 3 8.00185 3C6.06886 3 4.50185 4.567 4.50185 6.5V8.42893C4.50185 10.141 3.82639 11.7835 2.62304 13H13.3807ZM1.76962 13.8536L1.77015 13.853L1.76962 13.8536ZM1.41607 14.5H14.5876C15.4785 14.5 15.9247 13.4229 15.2947 12.7929L14.4663 11.9645C13.5286 11.0268 13.0019 9.75501 13.0019 8.42893V6.5C13.0019 3.73858 10.7633 1.5 8.00185 1.5C5.24043 1.5 3.00185 3.73858 3.00185 6.5V8.42893C3.00185 9.75501 2.47507 11.0268 1.53739 11.9645L0.70896 12.7929C0.0789954 13.4229 0.525163 14.5 1.41607 14.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57464_139001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyMeBellOutlined16);
export default __webpack_public_path__ + "static/media/notifyMeBellOutlined-16.d728781b.svg";
export { ForwardRef as ReactComponent };